import { render, staticRenderFns } from "./staff-form.vue?vue&type=template&id=6e5ff448&"
import script from "./staff-form.vue?vue&type=script&lang=ts&"
export * from "./staff-form.vue?vue&type=script&lang=ts&"
import style0 from "./staff-form.vue?vue&type=style&index=0&id=6e5ff448&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports